module.exports = __webpack_public_path__ + "4d709ce4a749feb7bfa5b52d050a63e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/create_workshop_info/accreditation@2x.jpg
// module id = 642
// module chunks = 0